import React from 'react';

export const PROCESS_CSID_INFO = () => (
    <div>
        <p>Defines if the CSID should be processed by our analytics tools.</p>
        <p>If switched off, the CSID will not be included as a tracking parameter
            in the stream URLs provided to the client by the AV-API.</p>
    </div>
);
export const ENFORCE_CSID_INFO = () => (
    <div>
        <p>Defines if the usage of the CSID should be enforced.</p>
        <p>If switched on, the CSID parameter will be required by the AV-API
            in order to provide stream URLs to the client.</p>
    </div>
);

export const TUNNEL_AUTOASSIGMENT_INFO = () => (
    <div>
        <p>Switch on this option if you want this tunnel to function as a placeholder.
        When associated to an encoding target, it will automatically be replaced by one of the other tunnels shortly before the start of the broadcast</p>
    </div>
);

export const FORCE_DUAL_STACK_INFO = () => (
    <div>
        <p>
            Defines if the hostname used in stream URLs provided to the client via the AV-API should always be dual-stack (IPv4 + IPv6).<br/>
            Switch on this option if the client uses an IP detection URL endpoint from the AV-API to detect IPs of end-users, or if the client detects the IPs of end-users itself and has dual-stack support on its own servers doing the IP detection.
        </p>
    </div>
);
